"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.standardShadowWithInset = exports.shadowInset = exports.createShadow = exports.overrideClasses = void 0;

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.array.concat.js");

var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;
var overrideClasses;
exports.overrideClasses = overrideClasses;

(function (overrideClasses) {
  overrideClasses["disabled"] = "&$disabled";
  overrideClasses["focusVisible"] = "&$focusVisible";
  overrideClasses["focused"] = "&$focused";
  overrideClasses["selected"] = "&$selected";
  overrideClasses["checked"] = "&$checked";
  overrideClasses["hover"] = "&:hover";
  overrideClasses["mediaHoverNone"] = "@media (hover: none)";
  overrideClasses["active"] = "&:active";
  overrideClasses["firstChild"] = "&:first-child";
  overrideClasses["lastChild"] = "&:last-child";
  overrideClasses["before"] = "&:before";
  overrideClasses["after"] = "&:after";
})(overrideClasses || (exports.overrideClasses = overrideClasses = {}));

var createShadow = function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0, 0, 0, ").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0, 0, 0, ").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0, 0, 0, ").concat(shadowAmbientShadowOpacity, ")")].join(',');
};

exports.createShadow = createShadow;

var shadowInset = function shadowInset(pxInset, color) {
  return "inset 0 0 0 ".concat(pxInset, "px ").concat(color);
};
/**
 * Returns a string with standard shadow + inset shadow with params
 * "theme.shadows[dp], inset 0 0 0 [pxInsetShadow] [colorInsetShadow]".
 * @param theme RocheTheme
 * @param dpMainShadow number
 * @param pxInsetShadow number
 * @param colorInsetShadow string
 */


exports.shadowInset = shadowInset;

var standardShadowWithInset = function standardShadowWithInset(theme) {
  return function (dpMainShadow, pxInsetShadow, colorInsetShadow) {
    return "".concat(theme.shadows[dpMainShadow], ",").concat(shadowInset(pxInsetShadow, colorInsetShadow));
  };
};

exports.standardShadowWithInset = standardShadowWithInset;